export default __webpack_public_path__ + "static/media/m_engineering_card03_2.fbd7bce5.png";